// TODO This is workaround for https://github.com/microsoft/TypeScript/issues/47663#issuecomment-1694517404
export * from '@tanstack/query-core';

import type { RhinoImageRatio } from '../image';

import { useCollection } from './useCollection';
import { useCollectionMeta } from './useCollectionMeta';

export type UseCollectionProps = {
  gridReferenceId: string;
  railReferenceId: string;
  pageSize: number;
  defaultPortraitImageHeight?: number;
  defaultLandscapeImageHeight?: number;
  defaultImageRatio?: RhinoImageRatio;
};

function createMeta(meta: NonNullable<ReturnType<typeof useCollectionMeta>['data']>) {
  return {
    collectionId: meta.collectionId,
    groupBy: meta.groupBy,
    isFilterByEntitlementRequired: meta.isFilterByEntitlementRequired,
    kSql: meta.kSql,
  };
}

export function useGridCollection({
  gridReferenceId,
  railReferenceId,
  pageSize,
  defaultPortraitImageHeight,
  defaultLandscapeImageHeight,
  defaultImageRatio,
}: UseCollectionProps) {
  const { data: meta } = useCollectionMeta({
    gridReferenceId,
    railReferenceId,
    defaultPortraitImageHeight,
    defaultLandscapeImageHeight,
    defaultImageRatio,
  });

  return useCollection({
    meta: meta ? createMeta(meta) : undefined,
    pageSize,
    referenceId: railReferenceId,
  });
}
